module.exports = __webpack_public_path__ + "img/youtube_logo.edad0130.svg";